<template>
  <div class="login">
    <div class="login-wrap" :class="{'is-pda': pda.status}">
      <div v-show="!pda.status" class="pic-part">
        <img :src="logoOrange" alt="" class="logo">
        <img class="scene" src="../assets/img/login/login_03.png" />
      </div>
      <div class="input-part">
        <img v-show="pda.status" :src="logoOrange" alt="" class="pda-logo">
        <h3>登录</h3>
        <h5>{{information.system_name}}</h5>
        <h5 class="sys-info">{{information.system_name_en}} {{version.full_verison}}</h5>
        <div class="input-item">
          <p>用户名</p>
          <el-input v-model="username" :placeholder="`请输入用户名`"></el-input>
        </div>
        <div class="input-item">
          <p>密码</p>
          <el-input
            v-model="password" 
            :type="showPassword ? 'text' : 'password'" 
            :placeholder="`请输入密码`" @keyup.enter.native="login()"
          >
            <i
              slot="suffix"
              class="pwd-suffix-icon" 
              :class="showPassword ? 'el-icon-open' : 'el-icon-turn-off'" @click="showPassword = !showPassword"
              :title="`显示密码`"
            ></i>
          </el-input>
        </div>
        <el-button class="login-btn" type="primary" @click="login()">
          <img src="../assets/img/login/login_05.png" alt="" class="btn-img">
          <span>登录</span>
        </el-button>
        <!-- <h6 class="info">技术支持: {{information.company_name}}</h6> -->
      </div>
      <div class="lang-options d-flex" v-show="version.locale_on">
        <span v-for="(item, index) in langOptions" :key="index" class="lang-item" :class="{'active': lang === item.localKey}" @click="changeLang(item)">
          {{ item.name }}
        </span>
      </div>
    </div>
    <el-dialog :title="`请选择供应室`" width="60%" :visible="showHandleCenter" :append-to-body="true" :show-close="false" :close-on-click-modal="false">
      <div style="display: flex; justify-content: center;margin: 0 auto 20px;">
        <el-select class="input200" v-model="handleCenterId" :placeholder="`请选择`">
          <el-option
            v-for="item in handleCenters"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="d-flex center">
        <el-button type="primary" @click="confirmHandleCenter()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="`请选择处理中心和科室`" width="60%" :visible="showDepartment" :append-to-body="true" :show-close="false" :close-on-click-modal="false">
      <div style="display: flex; justify-content: center;margin: 0 auto 20px;">
        <el-cascader
          class="input200"
          :placeholder="`请选择`"
          :popper-class="{'cascader-fix-height': true, 'mini-cascader' : pda.status}"
          v-model="useDpartment"
          :options="useDpartments">
        </el-cascader>
      </div>
      <div class="d-flex center">
        <el-button type="primary" @click="confirmDepartment()">确定</el-button>
      </div>
    </el-dialog>
    <div class="contract">
      <span>电话：{{information.company_phone}}</span>
      <span>邮箱：{{information.company_email}}</span>
      <br v-if="pda.status" />
      <span>地址：{{information.company_address}}</span>
    </div>
    <scan-button v-if="version.sys_config ? !version.sys_config[313] : true" @scaned="login" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { login, scanLogin, getCenter, setCenter, loginSSO, userSetDepartment, departmentStorageExpired } from '../api.js'
import { userTokenKey, langKey, apiLangKey } from '../utils/Config.js'
const logoOrange = require('@/assets/img/login/login_04.png')
export default {
  name: 'login',
  data() {
    const langValue = localStorage.getItem(langKey)
    return {
      lang: langValue,
      username: '',
      password: '',
      showHandleCenter: false,
      showDepartment: false,
      user: null,
      token: null,
      handleCenters: [],
      useDpartments: [],
      useDpartment: null,
      handleCenterId: '',
      redirectInfo: null,
      logoOrange: process.env.NODE_ENV.includes('dev') ? logoOrange : `${window.location.origin}/cdn/logo/honjo_orange.png`,
      showPassword: false
    }
  },
  created() {
    // this.checkParams()
    window.document.title = `红柚“安易溯”标签管家`
  },
  mounted() {
    this.$scan(document, {
      onScan: (code) => {
        if (code) {
          this.login(code)
        }
      }
    })
  },
  computed: {
    ...mapGetters(['pda', 'version', 'information', 'exec', 'langOptions'])
  },
  methods: {
    ...mapActions(['setUser']),
    checkParams() {
      // 检查路径参数，判断是否需要单点登录
      const { query } = this.$route
      if (Object.keys(query).length > 0) {
        this.loginSSO(query)
      }
    },
    loginSSO(query) {
      // 单点登录
      this.$request('post', loginSSO, query)
      .then((res) => {
        if (res) {
          this.handleLogin(res)
        }
      })
    },
    async login(scanCode) {
      // 登录接口
      let info
      let url = login
      if (scanCode) {
        url = scanLogin
        const time = parseInt(new Date().getTime()/1000)
        const md5ScanCode = this.$md5.hash(scanCode)
        const code = `${md5ScanCode}#${time}`
        const md5Code = this.$md5.hash(code)
        info = { code: scanCode, timestamp: time, code_md5: md5Code }
      } else {
        const { username, password } = this
        if (!username) {
          this.$message.error(`请输入用户名`)
          return
        }

        if (!password) {
          this.$message.error(`请输入密码`)
          return
        }

        info = { username, password }
      }
      const res = await this.$request('post', url, info)
      if (res) {
        // 登录成功
        this.handleLogin(res)
      }
    },
    async handleLogin(res) {
      // 处理登录后逻辑 
      const { token, user } = res
      // 替换header token, 防止不一致
      this.$cookie.set(userTokenKey, token)
      this.token = token
      this.user = user

      // if (department_range && department_range.length > 0) {
      //   // 多科室账号，需要选院区和科室
      //   this.redirectInfo = redirect || null
      //   this.useDpartments = department_range
      //   this.showDepartment = true
      // } else if (redirect) {
      //   // 自动跳转
      //   this.setInfo()
      //   this.handleRedirect(redirect)
      // } else {
      //   // 去首页
      //   this.setInfo()
      //   this.$router.replace('/index')
      // }
      const {
        query
      } = this.$route
      const {
        from,
        type
      } = query
      if (from && type !== 'login') {
        this.$router.push(`/${from}?loginType=${type}`)
      } else {
        this.setInfo()
        // this.$router.replace('/index')
        window.location.replace(`${this.$utils.siteBase()}index`)
      }
    },
    handleRedirect(redirect) {
      // 处理重定向
      const { url, action }  = redirect
      const path = url.startsWith('/') ? url : `/${url}`
      const q = {}
      let query = ''
      if (action && action.length > 0) {
        query = JSON.stringify(action)
      }
      if (query) {
        q.Q = query
      }
      
      const fullUrl = `${path}${query ? `?Q=${query}` : ''}`
      window.location.replace(fullUrl)
    },
    getCenter() {
      return this.$request('get', getCenter, { token: this.token })
      .then((res) => {
        if (res) {
          this.handleCenters = res
        }
      })
    },
    setInfo() {
      this.$cookie.set(userTokenKey, this.token)
      let centerInfo = {}
      const department = this.useDpartment ? this.useDpartment[this.useDpartment.length - 1] : 0
      if (this.handleCenterId || department) {
        centerInfo = {department_id: this.handleCenterId || department}
      }
      this.setUser(Object.assign(this.user, centerInfo))
    },
    confirmHandleCenter() {
      // 选择处理中心
      if (!this.handleCenterId) {
        this.$message.error(`请选择处理中心`)
        return
      }

      this.$request('post', setCenter, { center_id: this.handleCenterId, token: this.token })
      .then((res) => {
        if (res) {
          this.setInfo()
          this.showHandleCenter = false
          // this.$router.replace('/index')
          window.location.replace(`${this.$utils.siteBase()}index`)
        }
      })
    },
    confirmDepartment() {
      // 选择科室
      const department = this.useDpartment ? this.useDpartment[this.useDpartment.length - 1] : 0
      if (!department) {
        this.$message.error(`请选择科室`)
        return
      }

      this.$request('post', userSetDepartment, { department_id: department, token: this.token })
      .then((res) => {
        if (res) {
         this.setInfo()
         const { redirect } = res
         this.showDepartment = false
         if (this.redirectInfo) {
           this.handleRedirect(this.redirectInfo)
           this.redirectInfo = null
         } else if (redirect) {
           this.handleRedirect(redirect)
         } else {
          //  this.$router.replace('/index')
          window.location.replace(`${this.$utils.siteBase()}index`)
         }
        }
      })
    },
    async getExpireNumber() {
      // 获取科室无菌库过期物品数量
      const res = await this.$request('get', departmentStorageExpired)
      return res.number
    },
    changeLang(item) {
      const { apiKey, localKey } = item
      localStorage.setItem(apiLangKey, apiKey)
      localStorage.setItem(langKey, localKey)
      const { fullPath } = this.$route
      const url =  `${window.location.origin}/${apiKey}${fullPath}`
      
      window.location.href = url
    },
    
  }
}
</script>

<style lang="scss" scoped>
  .login {
    width: 100vw;
    height: 100vh;
    background-image: url('../assets/img/login/bg.png');
    background-position: top left;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .login-wrap {
      width: 900px;
      height: 500px;
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      position: relative;
      .pic-part {
        width: 500px;
        height: 100%;
        position: relative;
        .logo {
          width: 230px;
          margin: 50px 0 0 50px;
        }
        .scene {
          position: absolute;
          left: 30px;
          bottom: 34px;
          height: auto;
          width: 400px;
        }
      }
      .btn-img {
        height: 20px;
        width: auto;
        position: absolute;
        left: 20px;
        top: 6px;
      }
      .input-part {
        width: 300px;
        // padding: 0 15px;
        position: relative;
        .pda-logo {
          position: absolute;
          width: 150px;
          left: 0;
          top: 30px;
        }
        h3 {
          margin: 100px auto 10px;
        }
        h5 {
          color: gray;
        }
        .sys-info {
          font-size: 12px;
          margin-bottom: 40px;
        }
        .input-item {
          margin-top: 25px;
          p {
            color: #939090;
            font-size: 13px;
            font-weight: 600;
          }
        }
        .login-btn {
          margin: 40px 0 15px;
          width: 100%;
          padding: 10px 0;
          position: relative;
        }
        .info {
          color: #aba9a9;
          font-weight: 500;
          text-align: center;
        }
      }
      .lang-options {
        position: absolute;
        right: 10px;
        top: 10px;
        .lang-item {
          padding: 0 10px;
          cursor: pointer;
          border-right: 2px solid #606266;
          &.active {
            font-weight: bold;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
    .is-pda {
      width: 360px;
      padding: 0 0 0 30px;
    }
    .contract {
      height: 20px;
      bottom: 20px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      // white-space: nowrap;
      width: 100%;
      text-align: center;
      span {
        font-size: 14px;
        padding: 0 10px;
        font-weight: 600;
      }
    }
    /deep/ .pwd-suffix-icon {
      padding: 14px 0;
      cursor: pointer;
    }
  }
</style>